<script>
import {mapActions, mapState} from 'vuex'
import {validationMixin} from 'vuelidate'
import {required} from 'vuelidate/lib/validators'
import CustomNotification from '@/components/common/CustomNotification.vue'
import LargeTabHeader from "@/components/common/tabs/LargeTabHeader.vue";

const greaterThan = value => {
  return parseFloat(value) <= 60
};
const minValue = value => {
  return parseFloat(value) >= 5;
};
export default {
  name: 'DataCleaning',
  components: {
    LargeTabHeader,
    CustomNotification
  },
  mixins: [validationMixin],
  validations: {
    dataCleaning: {
      greaterThan,
      required,
      minValue
    }
  },
  data() {
    return {
      dataCleaning: '60',
      dataCleaningMinValue: 5,
      dataCleaningMaxValue: 60,
      settingsNotification: {
        state: false,
        message: '',
        type: 'success'
      }
    }
  },
  computed: {
    ...mapState({
      userSettings: state => state.settings
    }),
  },
  created() {
    this.assignUserSettingsValues()
  },
  methods: {
    ...mapActions(['saveUserSettings']),
    assignUserSettingsValues() {
      this.dataCleaning = this.userSettings.daysUntilDataCleaning
    },
    saveGenerals() {
      this.$v.$touch()
      this.saveUserSettings({
        daysUntilDataCleaning: this.dataCleaning
      })
      .then(() => {
        this.settingsNotification.state = false
        this.settingsNotification.type = 'success'
        this.settingsNotification.message =
          this.$t('global.save.settings.success')
      })
      .catch(() => {
        this.settingsNotification.type = 'error'
        this.settingsNotification.message =
          this.$t('global.save.settings.error')
      })
      .finally(() => {
        this.settingsNotification.state = true
      })
    }
  }
}
</script>
<template>
  <v-container fluid>
    <!--    HEADER-->
    <LargeTabHeader
      :title="$t('component.profile.accountManagement.delete.data')"
      :subtitle="$t('component.profile.accountManagement.delete.data.description')"/>
    <v-divider></v-divider>
    <v-row>
      <v-col>
          <CustomNotification
            v-model="settingsNotification.state"
            :notification-type="settingsNotification.type">
            <span class="body-2">
              {{ settingsNotification.message }}
            </span>
          </CustomNotification>
          <v-card flat tile outlined color="transparent" class="pa-4">
            <v-card-text>
              <v-row align="center" justify="center">
                <v-col cols="12" md="6">
                  <v-card outlined class="mb-4">
                    <v-card-text>
                      <v-row align="center" justify="center" class="text-center">
                        <v-col cols="12" class="justify-center">
                          <span>{{
                              $t('component.profile.accountManagement.data.cleaning', {days: userSettings.daysUntilDataCleaning})
                            }}</span>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <v-text-field
                            id="dataCleaning"
                            v-model="dataCleaning"
                            :label="$t('component.profile.accountManagement.days')"
                            outlined
                            dense
                            required
                            :rules="[v => $v.dataCleaning.greaterThan || $t('component.profile.accountManagement.range.max', { max: dataCleaningMaxValue }),
                              v => $v.dataCleaning.minValue || $t('component.profile.accountManagement.range.min', { min: dataCleaningMinValue })]"
                            @input="$v.dataCleaning.$touch()" />
                        </v-col>
                      </v-row>
                    </v-card-text>
                    <v-card-actions>
                      <v-row class="text-center">
                        <v-col class="pt-0">
                          <v-btn
                            id="saveParams"
                            class="text-center px-8"
                            color="primary"
                            :disabled="$v.$invalid"
                            @click.stop="saveGenerals">
                            {{ $t('button.save') }}
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
